<template>
  <div class="wrap">
    <v-header :inputName='2'></v-header>
    <div class="beiJing">
      <img class="banner" src="../../images/beiBody.jpg">
      <div class="text">
        <div class="m_centre">
          <div class="mlogo">
            <div class="centent">
              <div class="img" v-if="collegeObj.collegeId!=null"><img style="border-radius: 50px;"
                  :src="($resourcesUrl+'/college/'+`${collegeObj.collegeId}`+'/'+`${collegeObj.collegeIcon}`)"></div>
              <div class="txt">

                <h4>{{collegeObj.collegeName}}</h4>
                <p>
                  {{collegeObj.collegeEducational}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{collegeObj.collegeLevel}}
                </p>
              </div>
            </div>
            <div class="shoucang">
              <span v-if="userCang.indexOf(collegeObj.collegeId)==-1" @click="shou(collegeObj.collegeId)">收藏<img
                  src="../../../../static/img/shoucang.png"></span>
              <span @click="shou(collegeObj.collegeId)" class="active" v-else>已收藏<img
                  src="../../../../static/img/shoucang.png"></span>
            </div>
          </div>
          <ul class="mTab">
            <li :class="{active:index == i}" :style="{width: (100/titles.length)+'%' }" v-for="(item,i) in titles"><a
                @click="changetitle(i)"><i :class="'icon_0'+(i+1)"></i>{{item}}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="m_centre">
      <div class="mzixunWrap" v-if="index == 0">
        <div class="mzixunLeft white">
          <div class="abstractIitem">
            <div class="itemTile">
              <h3>学校简介</h3>
            </div>
            <div class="abstractText">
              <p class="text-indent" v-html="jianjie"></p>
            </div>
          </div>
          <div class="abstractIitem" v-if="collegeObj.collegeBoshiNum!=null||collegeObj.collegeShuoshiNum!=null">
            <div class="itemTile">
              <h3>科研教学</h3>
            </div>
            <div class="abstractText">
              <p>
                <span v-if="collegeObj.collegeBoshiNum!=0">博士点：{{collegeObj.collegeShuoshiNum}}个；</span>
                <span v-if="collegeObj.collegeShuoshiNum!=0">硕士点：{{collegeObj.collegeBoshiNum}}个；</span>
              </p>
            </div>
          </div>
          <div class="abstractIitem" v-if="jiiaoyanshili.boshiliudong!=null&&jiiaoyanshili.boshiliudong!=''">
            <div class="itemTile">
              <h3>博士后流动站</h3>
            </div>
            <div class="abstractText">
              <p v-html="jiiaoyanshili.boshiliudong"></p>
            </div>
          </div>
          <div class="abstractIitem" v-if="jiiaoyanshili.boshiinfo!=null&&jiiaoyanshili.boshiinfo!=''">
            <div class="itemTile">
              <h3>博士点</h3>
            </div>
            <div class="abstractText">
              <p v-for="item in jiiaoyanshili.boshiinfo.split(',')" style="margin-top:15px;">{{item}}</p>
            </div>
          </div>
          <div class="abstractIitem" v-if="jiiaoyanshili.shuoshiinfo!=null&&jiiaoyanshili.shuoshiinfo!=''">
            <div class="itemTile">
              <h3>硕士点</h3>
            </div>
            <div class="abstractText">
              <p v-for="item in jiiaoyanshili.shuoshiinfo.split(',')" style="margin-top:15px;">{{item}}</p>
            </div>
          </div>
          <div class="abstractIitem" v-if="jiiaoyanshili.keyanpingtai!=null&&jiiaoyanshili.keyanpingtai!=''">
            <div class="itemTile">
              <h3>科研平台</h3>
            </div>
            <div class="abstractText">
              <p v-for="item in jiiaoyanshili.keyanpingtai.split(',')" style="margin-top:15px;">{{item}}</p>
            </div>
          </div>
          <div class="abstractIitem" v-if="shizi.length!=0">
            <div class="itemTile">
              <h3>名师团队</h3>
            </div>
            <div class="abstractText">
              <p v-for="item in shizi" style="margin-top:15px;">{{item}}</p>

            </div>
          </div>
          <div class="abstractIitem" v-if="jiiaoyanshili.mingren!=null&&jiiaoyanshili.mingren!=''">
            <div class="itemTile">
              <h3>学校名人</h3>
            </div>
            <div class="abstractText">
              <p v-html="jiiaoyanshili.mingren"></p>
            </div>
          </div>
          <div class="abstractIitem" v-if="yange!=null&&yange!=''&&yange!='\n'">
            <div class="itemTile">
              <h3>院校沿革</h3>
            </div>
            <div class="abstractText">
              <p v-html="yange"></p>
            </div>
          </div>
        </div>
        <div class="abstractRight white">
          <div class="abstractIitem ">
            <div class="itemTile">
              <h3>院校信息</h3>
            </div>
            <div class="collegeRank" >
              <div class="info">
                <div class="item" v-if="collegeInfo.collegeRank!=null">
                  <div class="num">{{collegeInfo.collegeRank}}</div>
                  <div class="infotext">排名</div>
                </div>
                <div class="item" v-if="collegeInfo.byRate!=null">
                  <div class="num">{{((parseFloat(collegeInfo.byRate))*100).toFixed(2)}}%</div>
                  <div class="infotext">保研率</div>
                </div>
                <div class="item" v-if="collegeInfo.rk!=null">
                  <div class="num">{{collegeInfo.rk}}</div>
                  <div class="infotext">软科</div>
                </div>
                <div class="item" v-if="collegeInfo.xyh!=null">
                  <div class="num">{{collegeInfo.xyh}}</div>
                  <div class="infotext">校友会</div>
                </div>
                <div class="item" v-if="collegeInfo.area!=null">
                  <div class="num">{{collegeInfo.area}}</div>
                  <div class="infotext">所在城市</div>
                </div>
              </div>
              <div class="info" style="margin-top: 15px;">
                <div class="item" v-if="collegeObj.collegeNature!=null">
                  <div class="num">{{(collegeObj.collegeNature == 1 ?'公办':'民办')}}</div>
                  <div class="infotext">属性</div>
                </div>
                <div class="item" v-if="collegeObj.collegeSubject!=null">
                  <div class="num">{{collegeObj.collegeSubject}}</div>
                  <div class="infotext">类型</div>
                </div>
                <div class="item" v-if="collegeObj.collegeSubjection!=null" style="flex-wrap: nowrap;width: auto;">
                  <div class="num" style="flex-grow: 1;">{{collegeObj.collegeSubjection}}</div>
                  <div class="infotext">隶属</div>
                </div>
              </div>
              <!-- <div>男女比例</div> -->
            </div>
          </div>
          <div class="abstractIitem">
            <div class="itemTile">
              <h3>院校地址</h3>
            </div>
            <div class="mapBox">
              <!-- <div class="map">
                <myMap v-if="showmap" style="width: 464;height: 320px;" :address="collegeObj.collegeAddr"
                  :areaId="collegeObj.collegeArea"></myMap>
                <img src="../../images/map.png">
              </div> -->
              <div>


              </div>
              <div class="text">
                <p><img src="../../images/icon_gw.png">官网：<span>{{collegeObj.collegeWeb}}</span><a
                    v-clipboard:copy="collegeObj.collegeWeb" v-clipboard:success="onCopy" v-clipboard:error="onError"
                    class="copy"><img src="../../images/copy.png"></a></p>
                <p><img src="../../images/icon_dh.png">电话：<span v-html="collegeObj.collegeTel"> </span><a
                    v-clipboard:copy="collegeObj.collegeTel" v-clipboard:success="onCopy" v-clipboard:error="onError"
                    class="copy"><img src="../../images/copy.png"></a></p>
                <p><img src="../../images/icon_dz.png">地址：<span v-html="collegeObj.collegeAddr"></span><a
                    v-clipboard:copy="collegeObj.collegeAddr" v-clipboard:success="onCopy" v-clipboard:error="onError"
                    class="copy"><img src="../../images/copy.png"></a></p>
              </div>
            </div>
          </div>
          <div class="abstractIitem">
            <div class="itemTile">
              <h3>同类院校</h3>
            </div>
            <div>
              <div v-for="college in  collegeList">
                <div class="collegeitem">
                  <div class="Cont_img">
                    <img style="width: 100%;height: 100%;" :src="($resourcesUrl+'/college/'+`${college.collegeId}`+'/'+`${college.collegeIcon}`)" width="110px"
                      height="110px">
                  </div>
                  <div class="citem">
                    <div class="cname">
                    <router-link tag="a" target="_blank" style="color: #F21323;"
                        :to="'/xyzy_jianjie?num=0&id='+college.collegeId">{{college.collegeName}}</router-link></div>
                    <div class="Cont_Card"
                      v-if="college.collegeLevel!=null&&college.collegeLevel!=''">
                        {{college.collegeLevel}}
                    </div>
                    <icollege :item="college"></icollege>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <yuanxishezhi v-if="index == 1" :id="collegeId"></yuanxishezhi>
      <yuanxiaozhuanye v-if="index == 2" :id="collegeId"></yuanxiaozhuanye>
      <zhaoshengjianzhang v-if="index == 3" :id="collegeId"></zhaoshengjianzhang>
      <fengshuxian v-if="index == 4" :id="collegeId"></fengshuxian>
      <xueshengjiuye v-if="index == 5" :id="collegeId"></xueshengjiuye>
      <xioayuanshenghuo v-if="index == 6" :id="collegeId"></xioayuanshenghuo>
      <xioayuanshenghuo v-if="index == 7" :id="collegeId"></xioayuanshenghuo>
      <xioayuanshenghuo v-if="index == 8" :id="collegeId"></xioayuanshenghuo>
    </div>
    <!-- 右边固定 -->

    <zuoxuanfu1></zuoxuanfu1>

    <item7></item7>
  </div>
</template>
<script>
  import vHeader from '../../../components/vHeader.vue'
  import zuoxuanfu1 from '../../../components/zuoxuanfu1.vue'
  import item7 from '../../../components/item7.vue'
  import yuanxishezhi from './xyzy_yuanxishezhi.vue'
  import yuanxiaozhuanye from './yuanxiaozhuanye.vue'
  import zhaoshengjianzhang from './xyzy_zhaoshengjianzhang.vue'
  import fengshuxian from './xyzy_fengshuxian.vue'
  import xueshengjiuye from './xyzy_xueshengjiuye.vue'
  import xioayuanshenghuo from './xyzy_xioayuanshenghuo.vue'
  import icollege from "../../../components/icollege.vue";
  import myMap from './map.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      yuanxishezhi,
      zhaoshengjianzhang,
      fengshuxian,
      xueshengjiuye,
      xioayuanshenghuo,
      yuanxiaozhuanye,
      myMap,
      icollege
    },
    data() {
      return {
        // 导航选中
        index: 0,
        titles: [
          '院校简介',
          '院校设置',
          '开设专业',
          '招生简章',
          '分数详情',
          // '学生就业',
          // '院校生活',
        ],
        jianjie: "",
        shizi: [],
        collegeMajor: [],
        jiiaoyanshili: {},
        yange: "",
        yuanxi: [],
        xuekezhuanye: {},
        collegeObj: {},
        collegeInfo:{},
        collegeId: '',
        showmap: false,
        userCang: [],
        collegeList:[]

      }
    },
    created() {
      let _this = this;
      let userCang = this.$utils.getlocalStorage('userCang')
      if (userCang != null && userCang != '') {
        this.userCang = userCang.college
      }
      // this.college = this.$utils.getlocalStorage("collegeInfo");
      this.index = this.$route.query.num
      this.collegeId = this.$route.query.id

      this.$req.selectOne("collegeTable", {
        id: this.collegeId
      }).then(function(response) {
        if(response.data!=null){
          _this.collegeObj = response.data;
          if(response.data.college!=null){
            _this.collegeInfo = response.data.college;
          }
          _this.showmap = true;
          _this.changetitle(_this.index);
        }

        _this.getCollegeList(_this.collegeObj.collegeSubject);

      })
    },
    methods: {
      getCollegeList(type){
        let _this = this;
        this.$req.queryAllByLimit("collegeTable", {
          pageSize: 10,
          pageNum: 1,
          queryObj: {collegeSubject:type}
        }).then(function(response) {
          if(response.data!=null){
            _this.collegeList = response.data;
          }
        })
      },
      shou(id) {
        if (!this.$utils.tologin(this)) {
          return;
        }
        let _this = this;
        let flag1 = this.$utils.getLoginStatus();
        if (flag1) {
          let obj = this.$utils.getlocalStorage('userCang')
          let list = obj.major
          if (list.indexOf(id) == -1) {
            _this.$req.insert("collectionTable", {
              dataType: 1,
              dataId: id,
              userId:this.$utils.getlocalStorage('userInfo').userId
            }).then(function(resp) {
              if (resp.status == 0) {
                list.push(id);
                _this.userCang = list
                obj.major = list
                _this.$utils.setlocalStorage("userCang", obj);
              }
            })

          } else {
            _this.$req.batchDelete("collectionTable", {
              data_type: 2,
              data_id: id,
              userId:this.$utils.getlocalStorage('userInfo').userId
            }).then(function(resp) {
              if (resp.status == 0) {
                list.splice(list.indexOf(id), 1);
                _this.userCang = list
                obj.major = list
                _this.$utils.setlocalStorage("userCang", obj);
              }
            })
          }
        }
      },
      changetitle(index) {
        console.log(11)
        if (index == 4) {
          if (!this.$utils.tologin(this)) {
            return;
          } else {
            if (!this.$utils.getUserInfo(this)) {
              return;
            }
            if (!this.$utils.getFenshu(this)) {
              return;
            }
          }
        }
        this.index = index;
        if (this.index == 0 && this.jianjie == "") {
          this.getdata();
        }



      },
      getdata() {
        let _this = this;
        _this.$http.get(_this.$resourcesUrl + "/college/" + this.collegeId + "/jianjie.html").then(function(
          response) {
          _this.jianjie = response
        })

        _this.$http.get(_this.$resourcesUrl + "/college/" + this.collegeId + "/shizi.html").then(function(
          response) {
            if(response!=null&&response!=""&&response!="\n"){
              _this.shizi = response.split(",")
            }
        })
        _this.$http.get(_this.$resourcesUrl + "/college/" + this.collegeId + "/jiiaoyanshili.json").then(
          function(
            response) {
            _this.jiiaoyanshili = response
          })
        _this.$http.get(_this.$resourcesUrl + "/college/" + this.collegeId + "/yange.html").then(function(
          response) {
          _this.yange = response
        })
      },
      // 复制成功时的回调函数
      onCopy(e) {
        this.$message.success("内容已复制到剪切板！")
      },
      // 复制失败时的回调函数
      onError(e) {
        this.$message.error("抱歉，复制失败！")
      }

    }


  }
</script>

<style scoped>
  .shoucang span img {
    margin-left: 5px;
  }

  .shoucang .active {
    background: #F21323;
  }

  .shoucang span {
    width: 100px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(134deg, #3EC2FF 0%, #29A7E1 100%);
    opacity: 1;
    border-radius: 21px;
    color: white;
    padding: 0px 5px 0 5px;
  }

  .shoucang {
    margin-left: 10px;
  }

  .beiJing .text {
    padding-top: 90px;
  }

  .m_centre {
    padding-top: 40px;
  }

  .centent {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .mTab {
    margin-top: 15px;
  }


  .mapBox .text .copy {
    margin-top: -25px;
  }

  .wrap {
    background: #FBFBFB;
  }

  /* 右边固定 */
  .zuotab {
    height: auto;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%);
  }

  .zuotab figure {
    cursor: pointer;
    margin: 8px 0;
    width: 64px;
    height: 62px;
    border: 1px solid #FF0000;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .zuotab figure img {
    width: 20px;
    height: 20px;
  }

  .zuotab figure figcaption {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
  }
  .collegeRank{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
  .collegeRank .info{

    display: flex;
    flex-direction: row;
    justify-content: start;

  }
  .collegeRank .info .item{
    width: 80px;
    text-align: center;
  }
  .collegeRank .info .item .num{
    color: #F21323;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 5px;
  }
  .collegeitem{
    border: 1px solid #ddd;
    border-radius: 15px;
    padding: 5px;
    padding-left: 10px;
    display: flex;
    width: 450px;
    flex-direction: row;
    align-items: center;
    margin: 10px 0;
  }
  .Cont_img {
    width: 60px;
    height: 60px;
  }
  .Cont_Card{
    font-size: 14px;
    margin: 5px 0px;
  }
  .collegeitem .citem {
    margin-left: 15px;
  }
  .collegeitem .citem .cname {
    font-size: 18px;
    font-weight: 800;
    color: #F21323;
  }

</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/xyzy_jianjie.vue